import { useTranslations } from "next-intl";
import { memo } from "react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import InputButton from "@components/core/InputButton";
import catalogContexts from "@utils/constants/catalogContexts";

const OrderBySection = memo(function OrderBySection({
  context,
  currentOrderBy,
  orderByOptions,
  refineOrderBy,
}) {
  const t = useTranslations("catalog");

  function handleClick(option) {
    const eventData = { button: "filter", filter: "order_by", value: option.label };
    ahoy("$click", eventData);
    analytics.track("$click", eventData);

    refineOrderBy(option.value);
  }

  if ([catalogContexts.wishlist, catalogContexts.userlist].includes(context)) return null;

  return (
    <div className="px-3 py-4 border-bottom">
      <p
        data-testid={"order_by-title-mobile"}
        className="font-size-sm text-uppercase font-weight-bold mb-2"
      >
        {t("filters.section_titles.order_by")}
      </p>

      <div className="order-by-list-container">
        {orderByOptions.map((orderByOption) => {
          if (orderByOption.context !== context) return;

          return (
            <div
              key={`orderBy-${orderByOption.value}`}
              className="d-flex"
            >
              <InputButton
                title={t(`filters.order_by.${orderByOption.label}`)}
                variant="light-gray"
                checked={orderByOption.value === currentOrderBy}
                onClick={() => handleClick(orderByOption)}
                withTracking={false}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default OrderBySection;
